import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('zaptic-no-notifications')
export class NoNotifications extends LitElement {
    static styles = css`
        :host {
            background-color: var(--backgroundGrey);
            height: 100%;
        }

        zaptic-stack {
            padding: 40px;
            justify-content: center;
            box-sizing: border-box;
            background-color: var(--backgroundGrey);
        }

        zaptic-notification-bell {
            --NotificationBell-activeColor: var(--purple);
            --NotificationBell-passiveColor: var(--grey5);
            --NotificationBell-bellSize: 50px;
            padding-top: 20px;
        }

        .message {
            color: #88a0b6;
            font-size: 18px;
            font-weight: var(--font-weight-medium);
            text-align: center;
        }
    `

    render() {
        return html`
            <zaptic-stack vertical>
                <div class="message">${window.i18n('shared:no-notifications')}</div>
                <zaptic-notification-bell></zaptic-notification-bell>
            </zaptic-stack>
        `
    }
}
